function channels (value) {
    const color = String(value || '').replace(/\s*!important\s*$/, '').trim()
    const hex = /^#([a-f\d]{3}|[a-f\d]{6})$/i.exec(color)
    if (hex) {
        const full = hex[1].length === 3 ? hex[1].split('').map(c => c + c).join('') : hex[1]
        return [0, 2, 4].map(i => parseInt(full.substr(i, 2), 16))
    }
    const rgb = /^rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/i.exec(color)
    if (rgb) return rgb.slice(1).map(Number)
    return null
}

function luminance (rgb) {
    const linear = rgb.map(channel => {
        const value = channel / 255
        return value <= 0.04045 ? value / 12.92 : Math.pow((value + 0.055) / 1.055, 2.4)
    })
    return linear[0] * 0.2126 + linear[1] * 0.7152 + linear[2] * 0.0722
}

// Black or white provides at least 4.5:1 against every opaque sRGB background.
// Unknown CSS formats retain inheritance and need a measured theme review.
export function contrastText (background) {
    const rgb = channels(background)
    if (!rgb) return 'inherit'
    const value = luminance(rgb)
    return (value + 0.05) / 0.05 >= 1.05 / (value + 0.05) ? '#000000' : '#ffffff'
}

// Text-only brand colors used on the app's white/light-gray content surfaces.
export function contrastInk (foreground) {
    let rgb = channels(foreground)
    if (!rgb) return foreground
    const background = luminance([243, 243, 243])
    while ((background + 0.05) / (luminance(rgb) + 0.05) < 4.5) {
        rgb = rgb.map(value => Math.floor(value * 0.95))
    }
    return 'rgb(' + rgb.join(', ') + ')'
}



// WEBPACK FOOTER //
// ./src/accessibility/colors.js